<template>
  <div class="select-museum">
    <app-icon
      stroke-width="1.5"
      :name="'map-pin'"
      width="16"
      height="16"
      class="select-museum__icon"
    />

    <select
      :id="inputFieldId"
      :style="{ backgroundImage: 'url(' + downArrow() + ')' }"
      :disabled="data.disabled"
      ref="select"
      :class="'custom-select custom-select-museum ' + data.inputClass"
      v-bind:value="value"
      v-on="listeners"
    >
      <option disabled value="" hidden v-if="data.placeholder">
        {{ data.placeholder }}
      </option>

      <option
      v-for="(item, index) in data.list"
      :value="item.id"
      :disabled="item.disabled"
      :selected="item.id === value"
      :key="index"
    >
        {{ item[data.listValueField] }}
      </option>
    </select>
  </div>
</template>

<script>
import { InputMixin } from "./mixin/InputMixin.js";
import AppFunction from "../../helpers/app/AppFunction";

export default {
  name: "SelectInputMuseum",
  mixins: [InputMixin],
  methods: {
    downArrow() {
      if (this.$store.state.theme.darkMode) {
        return AppFunction.getAppUrl("images/chevron-down-dark.svg");
      }

      return AppFunction.getAppUrl("images/chevron-down.svg");
    },
  },
};
</script>

<style>
.select-museum {
  position: relative;
  width: 180px;
}

.select-museum__icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #dc3545;
  stroke: #dc3545;
  pointer-events: none;
  z-index: 2;
}

.custom-select-museum {
  width: 100%;
  height: 38px;
  padding-left: 38px !important;
  padding-right: 35px !important;

  border: 1px solid #dc3545 !important;
  border-radius: 8px !important;

  color: #dc3545 !important;
  background-color: #fff !important;

  font-weight: 500;
  cursor: pointer;

  box-shadow: none !important;
  transition: all 0.2s ease;
}

.custom-select-museum:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important;
  outline: none !important;
}

.custom-select-museum:disabled {
  background-color: #f8f9fa !important;
  cursor: not-allowed;
  opacity: 0.7;
}

.custom-select-museum option {
  color: #212529;
}
</style>